import { supabase } from './supabase'

/**
 * Преобразует путь фото из Storage в публичный URL
 * @param {string} photo - путь в бакете или уже полный URL
 * @param {string} [cacheBust] - опционально: добавить ?v= для обхода кэша (например profile.updated_at)
 * @returns {string}
 */
export function getPhotoPublicUrl(photo, cacheBust) {
  if (!photo) return ''
  let url
  if (photo.startsWith('http://') || photo.startsWith('https://')) {
    url = photo
  } else {
    const { data } = supabase.storage.from('photos').getPublicUrl(photo)
    url = data.publicUrl
  }
  if (cacheBust) {
    const sep = url.includes('?') ? '&' : '?'
    url = `${url}${sep}v=${encodeURIComponent(cacheBust)}`
  }
  return url
}

/**
 * Массив путей/URL в массив публичных URL
 * @param {string[]} photos
 * @param {string} [cacheBust] - опционально: обход кэша после обновления профиля
 * @returns {string[]}
 */
export function resolvePhotoUrls(photos, cacheBust) {
  if (!Array.isArray(photos) || photos.length === 0) return []
  return photos.map((p) => getPhotoPublicUrl(p, cacheBust)).filter(Boolean)
}
